import React from 'react';
import NumberFormat from 'react-number-format';

const CurrencyInput = ({ label, ...props }) => (
  <div className="bx--form-item">
    <label className="bx--label">{label}</label>
    <NumberFormat {...props} />
  </div>
);

export default CurrencyInput;



// WEBPACK FOOTER //
// ./src/components/CurrencyInput.js